import {Component, Inject, OnInit, SecurityContext} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {MAT_DIALOG_DATA, MatDialogModule} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {marked} from "marked";


@Component({
  selector: 'app-note-view',
  templateUrl: './note-view.component.html',
  styleUrls: ['./note-view.component.scss'],
  imports: [
    MatDialogModule,
    TranslateModule
  ],
  standalone: true
})
export class NoteViewComponent implements OnInit{
  renderedHtmlContent: SafeHtml = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
               private sanitizer: DomSanitizer) {


  }

  ngOnInit() {
 this.sanitizeHTML();
  }


  sanitizeHTML(){
    const htmlContent = this.convertMarkdownToHtml(this.data?.content);
    this.renderedHtmlContent = this.sanitizeHtmlContent(
      htmlContent
    );
  }

    public sanitizeHtmlContent(htmlString: any): SafeHtml {
    return this.sanitizer.sanitize(SecurityContext.HTML, htmlString)!;
  }

    convertMarkdownToHtml(markdown: string): string {
    return <string>marked.parse(markdown);
  }

}
